import type { ModelSchema } from 'ember-data';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

const CANCELLATION_POLICY_MAP: Record<string, string> = {
  super_strict_60: 'super_strict_60',
  super_strict_60_new: 'super_strict_60',
  super_strict_30: 'super_strict_30',
  super_strict_30_new: 'super_strict_30',
  flexible: 'flexible',
  flexible_new: 'flexible',
  moderate: 'moderate',
  moderate_new: 'moderate',
  luxury_moderate: 'moderate',
  luxury_moderate_14: 'moderate',
  firm: 'firm',
  firm_14: 'firm',
  better_strict_with_grace_period: 'firm',
  strict: 'strict',
  strict_new: 'strict',
  strict_14_with_grace_period: 'strict',
  luxury_super_strict_95: 'strict',
  luxury_super_strict_125: 'strict',
  non_refundable: 'non_refundable',
  'non-refundable': 'non_refundable',
  no_refund: 'non_refundable',
  luxury_no_refund: 'non_refundable',
  limited: 'limited',
};

export default class AirbnbQualityListingSerializer extends ApplicationSerializer {
  normalize(typeClass: ModelSchema, hash: object) {
    const data = super.normalize(typeClass, hash);

    // @ts-expect-error - we have no typings for the json api
    const cancellationPolicy = data.data.attributes.cancellationPolicy
      ? // @ts-expect-error - we have no typings for the json api
        CANCELLATION_POLICY_MAP[data.data.attributes.cancellationPolicy]
      : 'unknown';
    // @ts-expect-error - we have no typings for the json api
    data.data.attributes.cancellationPolicy = cancellationPolicy;

    // @ts-expect-error - we have no typings for the json api
    const qualityStatus = data.data.attributes.qualityStatus;
    if (qualityStatus === 'SUSPEND') {
      // @ts-expect-error - we have no typings for the json api
      data.data.attributes.qualityStatus = 'SUSPENDED';
    }

    return data;
  }
}
